module.exports = __webpack_public_path__ + "assets/img/logo-italia-solare.917dfedc.webp";